import "lazysizes";
import "lazysizes/plugins/attrchange/ls.attrchange";
import { createApp } from "vue";
import VueClickAway from "vue3-click-away";
import * as components from "@/components/index";
import UiAccordion from "@/components/ui/accordion.vue";
import UiDropdown from "@/components/ui/dropdown.vue";
import UiIcon from "@/components/ui/icon.vue";
import UiIntersect from "@/components/ui/intersect.vue";
import UiModal from "@/components/ui/modal.vue";
import useModal from "@/composables/modal";
import useNavigation from "@/composables/navigation";
const App = createApp({
    components: {
        ...components,
    },
    setup() {
        const { setModal, modalName } = useModal();
        const { isMenuOpen, toggleMenu } = useNavigation();
        return {
            isMenuOpen,
            modalName,
            setModal,
            toggleMenu,
        };
    },
});
// Global properties
App.config.globalProperties.blankImage =
    "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
// Global components
App.component("UiAccordion", UiAccordion);
App.component("UiDropdown", UiDropdown);
App.component("UiIcon", UiIcon);
App.component("UiIntersect", UiIntersect);
App.component("UiModal", UiModal);
App.use(VueClickAway);
App.mount("#app");
